import { strHash, TEST_USER_HASH } from '@/base/MaUtils'
import maDate from '@/base/MaDate'
import { maLogger } from '@/base/logger'
import * as ConfigVars from '@/base/constants/ConfigVars'

let FS_READY = false
let fs_event_queue = []

window._fs_ready = () => {
  FS_READY = true
  fs_event_queue.forEach(([ev_name, params]) => call_fs_method(ev_name, ...params))
  fs_event_queue = []
}

function initialize({ userInfo, impersonation }) {
  try {
    // just in case compare hashes for test email
    if (!userInfo || strHash(userInfo.username) === TEST_USER_HASH)
      return
    if (!ConfigVars.production)
      return

    // if impersonating reset the session
    if (impersonation) {
      call_fs_method('anonymize')
    }
    const prefix = impersonation ? `MA-admin:${impersonation}:` : ''
    const fsData = {
      displayName: `${prefix}${userInfo.username}`,
      email: `${prefix}${userInfo.username}`,
      pricingPlan_str: userInfo.productMap ? Object.values(userInfo.productMap).join(', ') : '',
      createdAt_date: maDate(+userInfo.createdAt * 1000).toDate(),
      maAdmin: !!impersonation,
      accountId: userInfo.accountId,
    }
    // if our admins logged in we have to give a different user id so it
    // won't mess up user info on FS
    const userId = `${prefix}${userInfo.userId}`
    call_fs_method('identify', userId, fsData)
  }
  catch (e) {
    maLogger.error('MaFullStory: failed to initialize', e)
  }
}

/**
 * Calls FS method once initialized, queues otherwise
 * @param method FS method name e.g identify, anonymize
 * @param params
 */
function call_fs_method(method, ...params) {
  if (FS_READY) {
    window.FS?.[method]?.(...params)
  }
  else {
    fs_event_queue.push([method, params])
  }
}

export default {
  initialize,
}
